module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-5th-3cf41d9a4a1380cd7226958674121c57.png";